import { render, staticRenderFns } from "./QuotationLogin.vue?vue&type=template&id=079c64e6"
import script from "./QuotationLogin.vue?vue&type=script&lang=ts"
export * from "./QuotationLogin.vue?vue&type=script&lang=ts"
import style0 from "./QuotationLogin.vue?vue&type=style&index=0&id=079c64e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports